module.exports = __webpack_public_path__ + "img/cu.a91c593d.svg";